import * as React from 'react';
import { useGetScopeGroupQuery } from "../../../apis/ScopeGroup.api";
import { PrimaryScopeGroup, ScopeGroup } from "../../../types/models/ScopeGroup";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: ScopeGroup;
};

export const ScopeGroupNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ScopeGroupName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetScopeGroupQuery(PrimaryScopeGroup.fromId(id))
    return (<ScopeGroupNameDisplay data={data}/>)
}

export default ScopeGroupName;
